import React, { useState } from 'react';
import { Alert, Button, Card, Spinner } from 'react-bootstrap';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebase-config';
import { useUser } from '../../context/UserContext';
import { reactivateAccount } from '../../services/accountLifecycleService';
import { formatLifecycleDate } from '../../platform/accountLifecycle';
import User from '../../models/User';
import './DeactivatedAccountGate.css';

function DeactivatedAccountGate() {
  const { user, setUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const deactivatedLabel = formatLifecycleDate(user?.deactivatedAt);
  const firstName = user?.firstName?.trim();

  const handleContinue = async () => {
    if (!user) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const lifecycle = await reactivateAccount(user);
      setUser(new User({ ...user, ...lifecycle }));
    } catch (reactivateError) {
      setError(reactivateError.message || 'Reaktivacija ni uspela.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeepDeactivated = async () => {
    await signOut(auth);
    setUser(null);
  };

  return (
    <div className="deactivated-account-gate">
      <Card className="deactivated-account-gate__card">
        <Card.Body>
          <p className="deactivated-account-gate__eyebrow">
            {firstName ? `Dobrodošli nazaj, ${firstName}` : 'Dobrodošli nazaj'}
          </p>
          <h1 className="deactivated-account-gate__title">
            Vaš račun je trenutno deaktiviran.
          </h1>
          <p className="deactivated-account-gate__question">
            Ali želite nadaljevati z uporabo portala ali račun obdržati deaktiviran?
          </p>
          {deactivatedLabel && (
            <p className="deactivated-account-gate__meta text-muted">
              Deaktiviran {deactivatedLabel}.
            </p>
          )}

          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <div className="deactivated-account-gate__actions">
            <Button variant="primary" onClick={handleContinue} disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Aktiviranje...
                </>
              ) : (
                'Da, nadaljuj'
              )}
            </Button>
            <Button
              variant="outline-secondary"
              onClick={handleKeepDeactivated}
              disabled={loading}
            >
              Ne, obdrži deaktiviran
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default DeactivatedAccountGate;
